import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Sidebar from './Sidebar';

class Layout extends Component {
    static displayName = Layout.name;

    render() {
        const { location } = this.props;
        const pathname = location && location.pathname;

        const isAdminHome = pathname === '/AdminClient/AdminMainMenu';

        const hideSidebar =
            pathname === '/AdminClient/TextDetails' ||
            pathname.startsWith('/AdminClient/TextDetails/') ||
            pathname === '/AdminClient/createIAsmarttext' ||
            pathname.startsWith('/AdminClient/createIAsmarttext/') ||
            pathname === '/AdminClient/CreateTraductionIA' ||
            pathname.startsWith('/AdminClient/CreateTraductionIA/');

        const shellClassName = isAdminHome
            ? 'app-shell app-shell--admin-home'
            : 'app-shell';
        return (

            <div>
                <div className={shellClassName}>
                    {!hideSidebar && <Sidebar />}
                    <div className="wrapper-content">

                        {this.props.children}
                      {/*  <div className="text-note">
                            Typix | global | support-typix@pixalione.com | ® Pixalione
                        </div>*/}
                    </div>

                </div>
            </div>
        );
    }
}

export default withRouter(Layout);
